import styled from 'styled-components';
import { Bar, BarButton, BarDivider } from './ui/Bar';
import { ui } from './ui/tokens';
import ZoomInIcon from '../assets/design/zoom-in.svg';
import ZoomOutIcon from '../assets/design/zoom-out.svg';
import FullscreenIcon from '../assets/design/fullscreen.svg';
import UndoIcon from '../assets/design/undo.svg';
import RedoIcon from '../assets/design/redo.svg';

export type TopBarProps = {
	zoomPercentage: number;
	onZoomIn: () => void;
	onZoomOut: () => void;
	onFullScreen: () => void;
	isFullScreen: boolean;
	onUndo: () => void;
	onRedo: () => void;
	canUndo: boolean;
	canRedo: boolean;
};

/**
 * Fixed nav above the canvas (style guide "Nav Top Canvas"):
 * zoom in / percentage / zoom out | full screen | undo, redo.
 */
function TopBar({ zoomPercentage, onZoomIn, onZoomOut, onFullScreen, isFullScreen, onUndo, onRedo, canUndo, canRedo }: TopBarProps) {
	return (
		<Bar role="toolbar" aria-label="Canvas view">
			<Group style={{ flex: 2.4 }}>
				<ZoomRow>
					<IconButton type="button" onClick={onZoomIn} aria-label="Zoom in">
						<img src={ZoomInIcon} alt="" width={28} height={28} draggable={false} />
					</IconButton>
					<Percentage aria-live="polite">{zoomPercentage}%</Percentage>
					<IconButton type="button" onClick={onZoomOut} aria-label="Zoom out">
						<img src={ZoomOutIcon} alt="" width={28} height={28} draggable={false} />
					</IconButton>
				</ZoomRow>
				<GroupLabel>Zoom</GroupLabel>
			</Group>
			<BarDivider />
			<Group style={{ flex: 1.2 }}>
				<BarButton icon={FullscreenIcon} label={'Full\nscreen'} onClick={onFullScreen} disabled={isFullScreen} />
			</Group>
			<BarDivider />
			<Group style={{ flex: 2, flexDirection: 'row' }}>
				<BarButton icon={UndoIcon} label="Undo" onClick={onUndo} disabled={!canUndo} />
				<BarButton icon={RedoIcon} label="Redo" onClick={onRedo} disabled={!canRedo} />
			</Group>
		</Bar>
	);
}

export default TopBar;

const Group = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 0;
`;

const ZoomRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;

const IconButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	display: flex;
	-webkit-tap-highlight-color: transparent;
`;

const Percentage = styled.span`
	min-width: 42px;
	text-align: center;
	font-family: ${ui.font};
	font-size: 11px;
	font-weight: 700;
	color: ${ui.gold};
`;

const GroupLabel = styled.span`
	margin-top: 4px;
	font-family: ${ui.font};
	font-size: 9px;
	font-weight: 700;
	text-transform: uppercase;
	color: ${ui.label};
`;
